import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 left-6 z-[9998] group"
          aria-label="Back to top"
        >
          {/* Outer Glow Effect */}
          <div className="absolute inset-0 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full blur-md opacity-50 group-hover:opacity-75 transition-opacity"></div>
          
          {/* Button Container */}
          <div className="relative bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 text-white p-4 rounded-full shadow-2xl hover:shadow-primary-500/50 transition-all duration-300 hover:scale-110 border-4 border-white/20 hover:border-white/40">
            {/* Inner Glow */}
            <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-full"></div>
            
            {/* Icon */}
            <div className="relative">
              <ChevronUp className="h-6 w-6 md:h-7 md:w-7 group-hover:-translate-y-1 transition-transform duration-300 drop-shadow-lg" />
            </div>
            
            {/* Pulse Animation Ring */}
            <div className="absolute inset-0 rounded-full border-2 border-white/30 animate-ping opacity-0 group-hover:opacity-100"></div>
          </div>
        </button>
      )}
    </>
  );
};

export default BackToTopButton;
